import { useQuery } from '@tanstack/react-query';
import { organizationDetailsService } from '../services/organization-details.service';
import { OrganizationDetailsDto } from '../types/dtos/organization/OrganizationDetailsDto';
import { CustomResponseEntity } from '../types/common';

const ORGANIZATION_DETAILS_KEY = 'organization-details';

export const useOrganizationDetails = (organizationId: string) => {
  return useQuery<CustomResponseEntity<OrganizationDetailsDto>>({
    queryKey: [ORGANIZATION_DETAILS_KEY, organizationId],
    queryFn: () => organizationDetailsService.getDetails(organizationId),
    enabled: !!organizationId,
  });
}; 